import axios from 'axios'
import https from 'https'
import store from '@/store'

const httpClient = axios.create({
  baseURL: AppConfig.url + '/api'
})
httpClient.CancelToken = axios.CancelToken
httpClient.isCancel = axios.isCancel

httpClient.interceptors.response.use(
  (res) => {
    return Promise.resolve(res)
  },
  (err) => {
    if (httpClient.isCancel(err)) {
      return Promise.reject(new Error('canceled'))
    } else {
      const { status } = err.response
      // 認証が出来ていない場合はログイン画面に遷移する
      if (status === 401) {
        store.dispatch('auth/logout')
      }
      return Promise.reject(err)
    }
  }
)

httpClient.interceptors.request.use((req) => {
  // Axios経由のHTTPS接続で証明書エラーが出るので暫定対応
  req.httpsAgent = new https.Agent({ rejectUnauthorised: false })
  return req
})

export default httpClient

export const handleSuccess = (res) => {
  return Promise.resolve(res.data)
}

export const handleError = (err) => {
  return Promise.reject(err)
}

export const apiHeader = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'X-Requested-With': 'XMLHttpRequest'
  }
}
